import React from 'react';
import createClass from 'create-react-class';
import {connect} from 'react-redux';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Button, Input, InputWrapper} from 'ui-library';
import i18n from 'i18n';

import {getCurrentUser} from 'modules/shared/selectors';

import Auth from '../actions/auth';
import App from '../actions/app';
import API from '../lib/api.js';
import {LoginSupportLinks as SupportLinks} from 'modules/shared/containers';
import { loginCoverImg, logoImgObs } from 'assets/images';
import {PartnerFormRoute} from 'apps/advertisers/PartnerForm';

const Actions = {Auth, App};
const A_DAY = 24;

const deepLinkState = require('../mixins/deepLinkState');
const emailRegex = require('../mixins/emailRegex');

function mapStateToProps(state) {
  return {
    currentUser: getCurrentUser(state)
  };
}

const VerifyEmailReminder = createClass({
  displayName: 'VerifyEmailReminder',

  propTypes: {
    currentUser: PropTypes.object,
    logout: PropTypes.func,
    currentLanguage: PropTypes.string.isRequired,
    partnerSettings: PropTypes.object
  },

  mixins: [
    deepLinkState,
    emailRegex
  ],

  getInitialState() {
    const {email} = this.props.currentUser;

    return {
      email,
      editEmail: false
    };
  },

  componentDidMount() {
    Actions.App.hideLoader();
  },

  componentDidUpdate(nextProps) {
    const {currentUser} = nextProps;

    if (currentUser && currentUser.createdAt && currentUser.verifiedEmails) {
      const createdAt = moment(currentUser.createdAt);
      const elapsedHours = moment().diff(createdAt, 'hours', true);

      const {verifiedEmails, email} = currentUser;
      const emailIsVerfied = verifiedEmails.indexOf(email.toLowerCase()) >= 0;

      if (elapsedHours < A_DAY || emailIsVerfied) {
        Actions.App.gotoPage('/');
      }
    }
  },

  onEditEmail(event) {
    event.preventDefault();
    this.setState({editEmail: true});
  },

  sendEmailVerification() {
    const data = {
      email: this.state.email
    };

    API.sendEmailVerification(data, (err, res) => {
      if (err) return Actions.App.displayAlert({message: res.message});

      return Actions.App.displayAlert({
        title: i18n.get('VERIFY_EMAIL_REMAINDER_SUCCESS_ALERT_TITLE'),
        type: 'success',
        message: i18n.get('VERIFY_EMAIL_REMAINDER_SUCCESS_ALERT_DESCRIPTION')
      });
    });
  },

  saveAndSendEmailVerification() {
    if (!this.emailRegex.test(this.state.email)) {
      const elem = ReactDOM.findDOMNode(this.refs.emailInput);
      elem.parentNode.classList.add('error');
      elem.focus();
      return;
    }

    API.updateCurrentUser({email: this.state.email}, (err, res) => {
      if (err) return Actions.App.displayAlert({message: res.message});
      this.setState({
        email: res.data.email,
        editEmail: false
      });

      Actions.App.displayAlert({
        title: i18n.get('DEFAULT_SUCCESS_TITLE'),
        type: 'success',
        message: i18n.get('VERIFY_EMAIL_SAVE_REMINDER_SUCCESS_ALERT_DESCRIPTION')
      });

      return this.sendEmailVerification();
    });
  },

  logoutHandler() {
    this.props.logout();
    Actions.Auth.signout();
  },

  handleEmailInputChange(e) {
    e.target.parentNode.classList.remove('error');
    this.setState({
      email: e.target.value
    });
  },

  render() {
    const {editEmail} = this.state;
    const {languageChange, currentLanguage, partnerSettings} = this.props;

    if (partnerSettings) return <PartnerFormRoute />;

    const emailInfo = (
      <div className='flex between-xs margin-vertical-2x'>
        <h3 data-uitest='email'>{this.state.email}</h3>

        <a onClick={this.onEditEmail} data-uitest='edit-email-link'>
          {i18n.get('VERIFY_EMAIL_EDIT')}
        </a>
      </div>
    );

    const emailCapture = (
      <div className='margin-vertical-2x'>
        <InputWrapper className='lg'>
          <i className='vf-icon icon-mail'></i>
          <Input
            name='email'
            type='email'
            ref='emailInput'
            className='login-input'
            placeholder={i18n.get('VERIFY_EMAIL_EMAIL_ADDRESS')}
            value={this.state.email}
            onChange={this.handleEmailInputChange}
            inputSize='lg'
          />
        </InputWrapper>
      </div>
    );

    return (
      <div className='vf-row no-space'>
        <div className='col-md-5 col-xs-12'>
          <div className='flex flex-row no-space start-md center-xs'>
            <div className='login'>
              <div className='background' />
              <div className='overlay' />

              <div className='form'>
                <img alt='' src={logoImgObs} className='logo' />

                <div className='title no-margin vf-text-gray-dark'>
                  {i18n.get('VERIFY_EMAIL_VERIFY_YOUR_EMAIL_TO_CONTINUE')}
                </div>

                <h4 className='vf-text-gray-dark'>
                  {i18n.get('VERIFY_EMAIL_YOU_MUST_VERIFY_YOUR_EMAIL')}
                </h4>

                <div>

                  {editEmail ? emailCapture : emailInfo}

                  <div className='vf-row no-margin between-xs width100'>
                    <div className='col-xs-12 col-md-6 flex center-xs margin-top-Hx'>
                      <Button
                        data-uitest='logout-button'
                        color='primary'
                        className='outline'
                        onClick={this.logoutHandler}
                      >
                        {i18n.get('VERIFY_EMAIL_EMAIL_SIGN_OUT')}
                      </Button>
                    </div>

                    <div className='col-xs-12 col-md-6 flex center-xs margin-top-Hx'>
                      <Button
                        color='primary'
                        data-uitest='send-email-button'
                        onClick={
                          editEmail ? this.saveAndSendEmailVerification : this.sendEmailVerification
                        }
                      >
                        {editEmail
                          ? i18n.get('VERIFY_EMAIL_SAVE_AND_VERIFY')
                          : i18n.get('VERIFY_EMAIL_SEND_AGAIN')
                        }
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              <SupportLinks />
            </div>
          </div>
        </div>

        <div className='col-md-7 hide-xs cover' style={{backgroundImage: `url('${loginCoverImg}')`}}>
          <div className='gradient login' />
        </div>
      </div>
    );
  }
});

export default connect(mapStateToProps)(VerifyEmailReminder);
